import React from "react";

const Cta = () => {
  return (
    <section className="flex justify-center bg-lightGreen-100">
      <div className="flex flex-col md:flex-row items-center md:mx-auto lg:max-w-[80%] py-12 md:space-x-16 space-y-2 md:space-y-0 px-16 ">
        <span className="text-center text-2xl font-bold text-darkGreen-100 pr-6">
          ¿Listo para optimizar el manejo de tus residuos?
        </span>
        <br />
        <button className="text-white cursor-pointer font-normal py-3 px-4 rounded-md mx-auto md:mx-0 shadow-xl hover:shadow-sm hover:translate-y-[1px] hover:bg-darkGreen-100 bg-darkGreen-80 border-none w-auto">
          <a
            href="https://wa.link/unxfc0"
            className="text-md text-white hover:text-white"
          >
            Envíanos un mensaje
          </a>
        </button>
      </div>
    </section>
  );
};

export default Cta;
